// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"statistic-info_tooltip__0Sa_S","question":"statistic-info_question__iEIAJ","hoverable":"statistic-info_hoverable__D6aQp","root":"statistic-info_root__ssGe_"};